module.exports = __webpack_public_path__ + "img/background.cc0201b5.png";